
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.638 7.203L14.542.828a.984.984 0 011.472 0l.981 1.06c.408.44.408 1.153 0 1.588L12.815 8l4.184 4.519c.409.44.409 1.153 0 1.589l-.98 1.064a.985.985 0 01-1.472 0L8.642 8.797a1.186 1.186 0 01-.004-1.594zM.303 8.797l5.904 6.375a.985.985 0 001.472 0l.98-1.06a1.184 1.184 0 000-1.589L4.48 8l4.184-4.52a1.184 1.184 0 000-1.589L7.683.828a.984.984 0 00-1.472 0L.307 7.203a1.186 1.186 0 00-.004 1.594z","fill":"#939393"}})])
          )
        }
      }
    